import { useContext, createContext } from 'react';

export interface IModalControls {
  open: () => Promise<void>;
  collapse: () => Promise<void>;
}

export interface IModalContext {
  isCloseAvailable: boolean;
  register: (name: string, controls: IModalControls) => void;
  unregister: (name: string) => void;
  open: (name: string) => Promise<void>;
  close: (name: string) => Promise<void>;
  portalNode: Element | null;
}

export const defaultValue: IModalContext = {
  isCloseAvailable: true,
  register: (): void => undefined,
  unregister: (): void => undefined,
  open: async (): Promise<void> => undefined,
  close: async (): Promise<void> => undefined,
  portalNode: null,
};

export const Context = createContext<IModalContext>(defaultValue);

export const useModalContext = (): IModalContext => useContext(Context);
